import React from 'react';
import { ThemeToggleButton } from './ThemeToggleButton';

interface PublicPageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showThemeToggle?: boolean;
}

export const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({
  children,
  className = '',
  showThemeToggle = true,
}) => {
  return (
    <div className={`min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors ${className}`}>
      {showThemeToggle && (
        <div className="fixed top-4 right-4 z-50">
          <ThemeToggleButton />
        </div>
      )}
      {children}
    </div>
  );
};
